import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import VariationViewModelType from './VariationViewModel.type';

type VariationPageType = VariationViewModelType & PageType;

export default (currentPage: PageType): currentPage is VariationPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Product_VariationViewModel;
};
